<template>
<div :key="routerKey" id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
// import TocaWow from '@toca/toca-wow';
// import '@toca/toca-wow/dist/style.css';
import cookies from "js-cookie";

export default {
  name: "File",
  computed: {
    ...mapState({
      isPcMode: (state) => state.isPcMode,
    }),
    routerKey() {
      return JSON.stringify(this.$route.query);
    },
  },
  data() {
    return {
      tocaWow: null,
    };
  },
  methods: {
    ...mapActions(["setIsPcMode"]),
  },
  created() {
    this.setIsPcMode();
  },
  mounted() {
    // this.tocaWow = new TocaWow('#tocaWow',
    //   {
    //     id: '1816020037627535362',
    //     env: 'qa',
    //     isPcMode: this.isPcMode,
    //     userInfo: {
    //       userId: cookies.get('userId'),
    //       token: cookies.get('token'),
    //       deviceId: cookies.get('deviceId'),
    //       memberId: cookies.get('memberId'),
    //       spaceId: cookies.get('spaceId'),
    //     },
    //     deviceType: 'WEB', // PC、WEB、H5
    //     close: () => {
    //       this.tocaWow.destroy();
    //       this.tocaWow = null;
    //     }
    //   }
    // );
  },
};
</script>

<style lang="scss">
body {
  margin: 0;
  padding: 0;
}

html,
body,
#app {
  height: 100%;
}

#app {
  margin: 0;
  padding: 0;
  width: 100vw;
  min-width: 0px;
}
</style>
